import React, { useState } from 'react';
import { Col, Flex, Row, Typography } from 'antd';
import { Box } from '@/components/common/atoms';
import { UserAddOutlined } from '@ant-design/icons';
import { COLORS } from '@/utils/static';
import styled from 'styled-components';
import { AddReferralModal } from '@/components/investor/modals';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AccountsList, AccountsTree } from '@/components/common/molecules';
import { Container } from '@/ui';

export const ProfileReferralsView = ({ refferalsPyramid, recommeders, agents }) => {
  const { t } = useTranslation();
  const investor = useSelector((state) => state.investor);
  const [addRefferalOpened, setAddRefferalOpened] = useState(false);

  return (
    <Container $paddingY={25}>
      <Container $marginBottom={36}>
        <Typography.Title level={2}>{t('Referrals')}</Typography.Title>
      </Container>

      <Box>
        <Row wrap gutter={[24, 48]}>
          {(investor.accountRole === 'RECOMMENDER' || investor.accountRole === 'AGENT') && (
            <Col span={8} md={8} sm={8} xs={24}>
              <Flex wrap={'nowrap'}>
                <Typography.Title level={4}>{t('My structure')} </Typography.Title>

                <AddButton
                  onClick={
                    investor.isAccessibleWithoutVerification
                      ? () => setAddRefferalOpened(true)
                      : investor.isUserVerified
                        ? () => setAddRefferalOpened(true)
                        : () => {}
                  }
                  $disabled={
                    investor.isAccessibleWithoutVerification ? false : !investor.isUserVerified
                  }
                />
              </Flex>
              <AccountsTree accounts={refferalsPyramid} emptyTitle={t('No structure yet')} />
            </Col>
          )}

          <Col span={8} md={8} sm={8} xs={24}>
            <Flex wrap={'nowrap'}>
              <Typography.Title level={4} style={{ marginBottom: '20px' }}>
                {t('My assistant')}{' '}
              </Typography.Title>
            </Flex>
            <AccountsList accounts={recommeders} emptyTitle={t('No assistant yet')} />
          </Col>

          <Col span={8} md={8} sm={8} xs={24}>
            <Flex wrap={'nowrap'}>
              <Typography.Title level={4} style={{ marginBottom: '20px' }}>
                {t('My agent')}{' '}
              </Typography.Title>
            </Flex>
            <AccountsList accounts={agents} emptyTitle={t('No agent yet')} />
          </Col>
        </Row>
      </Box>

      {(investor.accountRole === 'RECOMMENDER' || investor.accountRole === 'AGENT') && (
        <AddReferralModal open={addRefferalOpened} onClose={() => setAddRefferalOpened(false)} />
      )}
    </Container>
  );
};

const AddButton = styled(UserAddOutlined)`
  width: 32px;
  height: 32px;
  color: ${COLORS.blueAntd};
  cursor: pointer;
  margin-left: 8px;
  border-radius: 6px;
  transition: 0.2s;

  &:hover {
    box-shadow: 0px 2px 10px 2px rgba(0, 111, 255, 0.15) inset;
  }

  &:active {
    box-shadow: 0px 2px 10px 2px rgba(8, 111, 255, 0.32) inset;
  }

  > svg {
    width: 100%;
  }
  ${({ $disabled }) =>
    $disabled &&
    `
    opacity: .6;
    
    &:active, &:hover {
      cursor: not-allowed;
      box-shadow: unset;
    }
  `}
`;
